import React, { FC } from 'react';
import * as classes from './AdditionalInfoCard.module.scss';

interface Props {
  icon: string;
  title: string;
}

const AdditionalInfoCard: FC<Props> = ({ icon, title, children }) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.icon}>
        <img src={icon} alt='' />
      </div>
      <div className={classes.title}>{title}</div>
      <div>{children}</div>
    </div>
  );
};

export default AdditionalInfoCard;
